import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popup, Segment } from 'semantic-ui-react';
import config from '../../config';

import './Menu.css';
import logo from '../../assets/images/md_icon.png';

export default class Menu extends Component {
  static propTypes = {
    actions: PropTypes.array,
    currentTitle: PropTypes.string,
    className: PropTypes.string
  }

  render() {
    return (
      <div className={`MainMenu ${this.props.className ? this.props.className : ''}`}>
          <div className="main-header clearfix">
              <Popup
                trigger={
                  <div className="header__logo" style={{ cursor: 'pointer' }}>
                    {config.entity === '1screen' ? <a className="logo">
                        <svg className="icon icon_logo logo__icon" role="img">
                            <title>Logo</title>
                        </svg>
                    </a> : <img src={logo} alt="Logo" style={{ width: '32px', height: '32px' }} />}
                  </div>
                }
                content={
                  <div>
                    <Segment color='blue' compact href="http://eye.1screen.com" style={{ cursor: 'pointer' }}>
                      <a className="logo">
                          <svg className="icon icon_logo logo__icon" role="img">
                              <title>Logo</title>
                          </svg>
                      </a>
                    </Segment>
                    <Segment color='red' compact href="http://eye.mobile-direct.net" style={{ cursor: 'pointer' }}>
                      <img src={logo} alt="Logo" style={{ width: '32px', height: '32px' }} />
                    </Segment>
                  </div>
                }
                on='click'
                position='right center'
              />
              <div className="header__right">
                  <div className="actions">
                      {this.props.actions ? this.props.actions.map((action, idx) => (
                          <div className="action">
                              <a {...action}>{action.title}</a><span>{ idx !== this.props.actions.length - 1 ? '|' : null }</span>
                          </div>
                      )) : null}
                  </div>
              </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MenuComponent/Menu.js